module.exports = __webpack_public_path__ + "static/img/29.f937dc79.png";